import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@repo/shared-client/components/ui'
import { cn } from '@repo/shared-client/lib/utils'
import { UserRole } from '@repo/shared-common'
import { useLocation } from '@tanstack/react-router'
import { useTranslation } from '@web/src/lib/intl/react'
import { EyeIcon, EyeOffIcon } from 'lucide-react'
import toast from 'react-hot-toast'
import { useSFContext } from 'src/contexts/sf-context'
import SFHelpPopup from '../../components/primatives/sf-help-popup/sf-help-popup'
import { useAuth } from '../../hooks/use-auth'

const NSFWToggle = () => {
  const { t } = useTranslation()
  const { isNSFWEnabled, disableFeature, toggleNSFWMode } = useSFContext()
  const { currentUserRole } = useAuth()
  const { pathname } = useLocation()
  const showContentFilterHelp = pathname === '/feed'

  const handleToggle = () => {
    if (currentUserRole === UserRole.TRADESHOW) {
      toast.error(t('Tradeshow accounts are not allowed to change the content filter.'))
      return
    }

    toggleNSFWMode()
  }

  const helpContent = (
    <div className="flex flex-col gap-3 text-justify">
      <p className="text-sm">{t('Shows and hides not safe for work content.')}</p>
    </div>
  )

  const toggleLabel = t('Safe for work image toggle')

  return (
    <div className="flex flex-col gap-0">
      <Tooltip>
        <TooltipTrigger
          render={
            <Button
              aria-label={toggleLabel}
              className={cn(disableFeature && 'hidden')}
              onClick={handleToggle}
              size="icon"
              type="button"
              variant="ghost"
            />
          }
        >
          {isNSFWEnabled ? <EyeOffIcon aria-hidden className="size-7" /> : <EyeIcon aria-hidden className="size-7" />}
        </TooltipTrigger>
        <TooltipContent side="bottom">{toggleLabel}</TooltipContent>
      </Tooltip>
      {showContentFilterHelp ? (
        <SFHelpPopup
          actionText={t('Account Settings')}
          autoShow={true}
          content={helpContent}
          cookieName="dismissNSFWToggleHelp"
          neverExpire={true}
          positioning={{ placement: 'bottom' }}
          title={t('Content Filter Toggle')}
        >
          <div className="size-px" />
        </SFHelpPopup>
      ) : null}
    </div>
  )
}

export default NSFWToggle
